<template>
	<div v-show="props.contract" class="col-span-full xl:col-span-4 bg-white border border-gray-200 text-sm rounded-lg overflow-hidden">
		<div class="border-b-3 border-gray-200">
			<div :class="props.blue ? 'bg-primary-600 text-white' : 'text-gray-800 border-b-2 border-gray-200'" class="flex items-center gap-1 font-semibold uppercase p-3">
				<icon name="ri-information-line" :class="props.blue ? 'text-white' : 'text-gray-500'" />
				Información
			</div>
			<div class="p-3">
				<ul class="flex flex-wrap gap-4 gap-y-0">
					<li v-if="props.contract?.rate" class="flex items-center text-[#1E293B]">
						<span class="bg-primary-600 rounded-full h-[7px] w-[7px] mr-2"></span>
						<span class="mr-2 font-bold text-[18px]"> {{ parseRate(props.contract.rate) }} </span>
						<span class="font-semibold">Tarifa</span>
					</li>
					<li v-if="props.contract?.annualkWh" class="flex items-center text-[#1E293B]">
						<span class="bg-primary-600 rounded-full h-[7px] w-[7px] mr-2"></span>
						<span class="mr-2 font-bold text-[18px]">{{ contract.annualkWh }}</span>
						<span class="font-semibold">/kWh</span>
					</li>
				</ul>

				<div v-if="lead && !props.price && !props.hidePrice" class="flex items-center text-[#1E293B]">
					<span class="bg-primary-600 rounded-full h-[7px] w-[7px] mr-2"></span>
					<span class="mr-2 font-bold text-[18px]">Gratuito</span>
					<span class="font-semibold">Precio</span>
				</div>

				<div v-if="lead && lead.origin && lead.origin.label" class="flex items-center text-[#1E293B]">
					<span class="bg-primary-600 rounded-full h-[7px] w-[7px] mr-2"></span>
					<span class="mr-2 font-bold text-[18px]">{{ lead.origin.label }}</span>
					<span class="font-semibold">Origen</span>
				</div>

				<div v-if="lead && lead.actualCompany" class="flex items-center text-[#1E293B]">
					<span class="bg-primary-600 rounded-full h-[7px] w-[7px] mr-2"></span>
					<span class="mr-2 font-bold text-[18px]">{{ lead.actualCompany }}</span>
					<span class="font-semibold">Compañía actual</span>
				</div>

				<div v-if="lead && props.distance" class="flex items-center text-[#1E293B]">
					<span class="bg-primary-600 rounded-full h-[7px] w-[7px] mr-2"></span>
					<span class="mr-2 font-bold text-[18px]">{{ props.distance.toFixed(1) }}m</span>
					<span class="font-semibold">Distancia</span>
				</div>

				<div class="flex items-center text-[#1E293B]" v-if="props.deactivateAt">
					<span class="bg-primary-600 rounded-full h-[7px] w-[7px] mr-2"></span>
					<span class="mr-2 font-bold text-[18px]">{{ dayjs(props.deactivateAt).format('DD/MM/YYYY HH:mm') }}</span>
					<span class="font-semibold">Fecha desactivación</span>
				</div>
			</div>
		</div>
		<div v-if="lead" class="bg-white text-gray-800 font-semibold">
			<div v-if="props.contract.cups" class="border-gray-200 border-y-3">
				<div class="flex items-stretch p-3">
					<icon name="ri-lock-line" class="opacity-70 w-5 h-5 mr-1" />
					<span class="uppercase">Datos de contrato</span>
				</div>
				<div class="flex items-center gap-4 justify-between md:justify-start p-3 border-t-2 border-gray-200">
					<span>CUPS:</span>
					<span :class="props.price && props.price > 0 ? 'blur-sm' : ''">{{ props.contract.cups }}</span>
				</div>
			</div>
			<div v-if="props.price && props.contract.customer && (props.contract.customer?.name || props.contract.customer?.lastname || props.contract.customer?.customerType)" class="border-gray-200 border-y-3">
				<div class="flex items-stretch p-3">
					<icon name="ri-user-line" class="opacity-70 w-5 h-5 mr-1" />
					<span class="uppercase">Datos de cliente</span>
				</div>
				<div class="flex flex-col md:flex-row md:flex-wrap gap-9 p-3 border-t-2 border-gray-200">
					<div v-if="props.contract.customer?.name" class="flex items-center justify-between gap-4 md:justify-start">
						<span>NOMBRE:</span>
						<span>{{ props.contract.customer?.name }}</span>
					</div>
					<div v-if="props.contract.customer?.lastname" class="flex items-center justify-between gap-4 md:justify-start">
						<span>APELLIDOS:</span>
						<span :class="props.price && props.price > 0 ? 'blur-sm' : ''">{{ props.contract.customer?.lastname }}</span>
					</div>
					<div v-if="props.contract.customer?.customerType" class="flex items-center justify-between gap-4 md:justify-start">
						<span>TIPO DE CLIENTE:</span>
						<span :class="props.price && props.price > 0 ? 'blur-sm' : ''">{{ props.contract.customer?.customerType }}</span>
					</div>
				</div>
			</div>
			<LeadAddress :lead="lead" v-if="(lead && lead.loc) || lead.contract.address.full || lead.contract.address.state || lead.contract.address.city || lead.contract.address.zipcode" :project="props.project" />
			<div v-if="props.price && props.contract.customer?.phones && props.contract.customer?.phones.length > 0" class="border-gray-200 border-y-3">
				<div class="flex items-stretch p-3">
					<icon name="ri-phone-line" class="opacity-70 w-5 h-5 mr-1" />
					<span class="uppercase">Teléfonos ({{ props.contract.customer?.phones.length }})</span>
				</div>
				<div class="flex flex-col md:flex-row md:flex-wrap gap-9 p-3 border-t-2 border-gray-200">
					<div class="flex items-center justify-between md:justify-start gap-4">
						<span>TELÉFONO 1:</span>
						<span :class="props.price && props.price > 0 ? 'blur-sm' : ''">{{ props.contract.customer?.phones[0].number }}</span>
					</div>
					<div v-if="props.contract.customer?.phones.length > 1" class="flex items-center justify-between md:justify-start gap-4">
						<span>TELÉFONO 2:</span>
						<span :class="props.price && props.price > 0 ? 'blur-sm' : ''">{{ props.contract.customer?.phones[1].number }}</span>
					</div>
				</div>
			</div>
			<div v-if="props.price && props.contract.customer?.emails && props.contract.customer?.emails.length > 0" class="border-gray-200 border-y-3">
				<div class="flex items-stretch p-3">
					<icon name="ri-phone-line" class="opacity-70 w-5 h-5 mr-1" />
					<span class="uppercase">Emails ({{ props.contract.customer?.emails.length }})</span>
				</div>
				<div class="flex flex-col md:flex-row md:flex-wrap gap-9 p-3 border-t-2 border-gray-200">
					<div class="flex items-center justify-between md:justify-start gap-4">
						<span>EMAIL 1:</span>
						<span :class="props.price && props.price > 0 ? 'blur-sm' : ''">{{ props.contract.customer?.emails[0].address }}</span>
					</div>
					<div v-if="props.contract.customer?.emails.length > 1" class="flex items-center justify-between md:justify-start gap-4">
						<span>EMAIL 2:</span>
						<span :class="props.price && props.price > 0 ? 'blur-sm' : ''">{{ props.contract.customer?.emails[1].address }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="p-3 border-y-3 border-gray-200" v-if="props.contract?.lastSupplierChange || props.contract?.lastReading">
			<div class="flex items-center text-xs text-gray-800 font-semibold uppercase">
				<icon name="ri-list-check" class="text-gray-400 mr-1" />
				<div>Detalles</div>
			</div>
			<ul>
				<li v-if="props.contract?.lastSupplierChange" class="flex items-center py-1">
					<icon name="ri-calendar-fill" class="text-green-500 mr-1" />
					<div class="text-sm">
						Cambio comercializadora hace
						{{ dayjs().diff(contract.lastSupplierChange, 'month') }}
						meses
					</div>
				</li>
				<li v-if="props.contract.lastReading" class="flex items-center py-1">
					<icon name="ri-check-line" class="text-green-500 mr-1" />
					<div class="text-sm">
						Registro actualizado
						{{ dayjs(contract.lastReading).fromNow() }}
					</div>
				</li>
			</ul>
		</div>
		<Accordion v-if="props.contract && (props.contract.powerP1 || props.contract.kWhP1 || props.contract.measureEquipmentProperty)" title="Ver más" class="border-0 border-t-3 border-gray-200 rounded-t-none">
			<ContractSummaryEnergyDetails :contract="props.contract" />
		</Accordion>
	</div>
</template>
<script setup lang="ts">
import Accordion from '@/apps/go/components/Accordion.vue'
import ContractSummaryEnergyDetails from '@/apps/go/components/leads/ContractSummaryEnergyDetails.vue'
import LeadAddress from '@/apps/go/components/leads/LeadAddress.vue'
import { Contract } from '@/apps/go/interfaces/Contract'
import { dayjs } from '@/services/dayjs'
import { parseRate } from '../../utils/parseRate'
import { Lead } from '../../interfaces/Lead'
const props = defineProps<{ contract: Contract; price?: number; deactivateAt?: string; lead?: Lead; project?: string; distance?: number; hidePrice?: boolean; blue?: boolean }>()
</script>

<style lang="scss" scoped>
sub {
	bottom: -0.15em;
}
</style>
